// extracted by mini-css-extract-plugin
export var askAiIcon = "_mn-j";
export var category = "_mn-9";
export var categoryHeader = "_mn-e";
export var container = "_mn-0";
export var group = "_mn-a";
export var groupItems = "_mn-f";
export var groupSeparator = "_mn-k";
export var loading = "_mn-1";
export var noResults = "_mn-3";
export var placeholder = "_mn-2";
export var resultContent = "_mn-5";
export var resultIcon = "_mn-c";
export var resultItem = "_mn-g";
export var resultMeta = "_mn-8";
export var resultSubtitle = "_mn-7";
export var resultSuffix = "_mn-i";
export var resultTitle = "_mn-6";
export var resultsList = "_mn-4";
export var searchGroup = "_mn-d";
export var selected = "_mn-h";
export var subgroup = "_mn-b";